import { AuthState, useAuth } from "auth/useAuth";
import { FullPageContentContainer } from "@vyne-shared/components/vyneNavigation/PageContentContainers";
import { Layout, Result } from "antd";
import { Navigation } from "components/Navigation/Navigation";
import { PageHeaderContent } from "components/Navigation/pageHeader/PageHeader";
import { PageLoading } from "components/Navigation/pageLoading/PageLoading";

const { Content } = Layout;

const accessDeniedMessage = "Your session has expired. Please log in again.";
const missingCredentialsMessage =
    "No Vyne credentials are present. Please make sure to access Payments from the main menu.";

// Trigger a login attempt on initial load
void useAuth.getState().doLogin();

/** Main component for Payments application. Provides routing and common UI elements. */
export const App = () => {
    const authState = useAuth((state) => state.authState);

    return (
        <Layout>
            {authState !== AuthState.Success && <PageHeaderContent isHistory={false} isStripe={false} />}
            {authState === AuthState.Success && <Navigation />}
            {authState === AuthState.InProgress && (
                <Content>
                    <PageLoading type="PaymentsLanding">Logging in to Vyne Payments</PageLoading>
                </Content>
            )}
            {authState === AuthState.Error && (
                // NOTE: You can trigger this by opening https://localhost:3000/?authToken=foo&registrationToken=bar
                <Content>
                    <FullPageContentContainer>
                        <Result status="403" title="Access denied" subTitle={accessDeniedMessage} />
                    </FullPageContentContainer>
                </Content>
            )}
            {authState === AuthState.NoCredentials && (
                // NOTE: You can trigger this by opening https://localhost:3000
                <Content>
                    <FullPageContentContainer>
                        <Result status="500" title="Missing credentials" subTitle={missingCredentialsMessage} />
                    </FullPageContentContainer>
                </Content>
            )}
        </Layout>
    );
};
